import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Stepper from "../../Component/Stepper";
import BasicInformation from "../../Component/KeyboardTheme/BasicInformation";
import PopupSettings from "../../Component/KeyboardTheme/PopupSettings";
import KeysSettings from "../../Component/KeyboardTheme/KeysSettings";
import OtherKeys from "../../Component/KeyboardTheme/OtherKeys";
import FontsPanel from "../../Component/KeyboardTheme/FontsPanel";
import FontsContent from "../../Component/KeyboardTheme/FontsContent";
import OtherOptionsPanel from "../../Component/KeyboardTheme/OtherOptionsPanel";
import validateStep from "../../helpers/CheckValidateStep";
import Cookies from "js-cookie";
import { API } from "../../App";
import { toast } from "react-toastify";

const KeyboardThemeAdd = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [stepValidated, setStepValidated] = useState({});

  const steps = [
    "Basic Information",
    "Popup Settings",
    "Keys Settings",
    "Other Keys",
    "Fonts Panel",
    "Fonts Content",
    "Other Options",
  ];

  const stepComponents = [
    BasicInformation,
    PopupSettings,
    KeysSettings,
    OtherKeys,
    FontsPanel,
    FontsContent,
    OtherOptionsPanel,
  ];

  const makeDefaultKeyStyle = () => ({
    bgType: "color",
    bgColor: ["#000000"],
    bgOrientation: null,
    borderColor: "#000000",
    borderWidth: 0,
    corners: 0,
    textColor: "#000000",
    opacity: 1,
  });

  const defaultFontsCategory = {
    textNormalColor: "#000000",
    textSelectedColor: "#000000",
    selectedBgColor: ["#000000"],
    bgOrientation: null,
    selectedBorderColor: "#000000",
    selectedBorderWidth: 0,
    corners: 0,
  };

  const [files, setFiles] = useState({
    keyboard_full_image_watch_ad: null,
    thumb_image: null,
    thumb_image_iphone: null,
    thumb_image_ipad: null,
    full_image_iphone: null,
    full_image_ipad: null,
    json_name: null,
    keyboard_bg_image: null,
    keysBgImage: null,
    keysIpadBgImage: null,
    keysBgImageLandscape: null,
    keysIpadBgImageLandscape: null,
    popupBgImage: null,
    popupBgSideImage: null,
    dropDownImage: null,
    fontsContentImage: null,
    fontsContentSelectionIconImage: null,
    gifBackImage: null,
    otherKeys: {},
  });

  const [fileNames, setFileNames] = useState({
    keyboard_full_image_watch_ad: null,
    thumb_image: null,
    thumb_image_iphone: null,
    thumb_image_ipad: null,
    full_image_iphone: null,
    full_image_ipad: null,
    json_name: null,
    keyboard_bg_image: null,
    keysBgImage: null,
    keysIpadBgImage: null,
    keysBgImageLandscape: null,
    keysIpadBgImageLandscape: null,
    popupBgImage: null,
    popupBgSideImage: null,
    dropDownImage: null,
    fontsContentImage: null,
    fontsContentSelectionIconImage: null,
    gifBackImage: null,
    otherKeys: {},
  });

  const [formData, setFormData] = useState({
    // Basic Information
    rank: "",
    name: "",
    loop_Mode: 0,
    keyboardCategory: "",
    status: true,
    is_premium: true,
    is_Border: true,
    is_Watch_Video: true,

    // Popup Settings
    popup: {
      bgType: "color",
      bgColor: ["#000000"],
      bgOrientation: null,
      textColor: "#000000",
      accentKeyBGColor: "#000000",
      accentKeyTextColor: "#000000",
    },

    // Keys Settings
    keys: {
      bgType: "color",
      bgColor: ["#000000"],
      bgOrientation: null,
      borderColor: "#000000",
      borderWidth: 0,
      corners: 0,
      textColor: "#000000",
      opacity: 1,
    },

    // Other Keys
    otherKeys: {
      shift: makeDefaultKeyStyle(),
      numSwitch: makeDefaultKeyStyle(),
      emoji: makeDefaultKeyStyle(),
      audio: makeDefaultKeyStyle(),
      space: makeDefaultKeyStyle(),
      return: makeDefaultKeyStyle(),
      backspace: makeDefaultKeyStyle(),
    },

    // Fonts Panel
    fontsPanel: {
      mainBgColor: "#000000",
      separatorColor: "#000000",
      dropDownBgColor: ["#000000"],
      dropDownBgOrientation: null,
      switchBgColor: "#000000",
      category: { ...defaultFontsCategory },
      opacity: 1,
    },

    // Fonts Content Section
    fontsContent: {
      bgType: "color",
      separatorColor: "#000000",
      textNormalColor: "#000000",
      textSelectedColor: "#000000",
      bgColorOrientation: null,
      normalBgColor: ["#000000"],
      selectedBgColor: ["#000000"],
      selectedBgOrientation: null,
      selectedBorderColor: "#000000",
      selectedBorderWidth: 0,
      normalBorderColor: "#000000",
      normalBorderWidth: 0,
      opacity: 1,
      corners: 0,
      gifCategoryData: {
        searchIconColor: "#000000",
        searchTextColor: "#000000",
        searchBackgroundColor: "#000000",
        searchBorderColor: "#000000",
        searchOpacity: 1,
      },
    },

    // Other Options Panel Section
    otherOptionsPanel: {
      mainBgColor: ["#000000"],
      mainBgOrientation: null,
      optionBgNormalColor: "#000000",
      optionBgSelectedColor: "#000000",
      optionTintNormalColor: "#000000",
      optionTintSelectedColor: "#000000",
      borderBottomColor: "#000000",
    },
  });

  const onInputChange = ({ target: { name, value, dataset } }) => {
    if (name.includes(".")) {
      const keys = name.split(".");
      setFormData((prev) => {
        let updated = { ...prev };
        let nested = updated;

        for (let i = 0; i < keys.length - 1; i++) {
          nested[keys[i]] = Array.isArray(nested[keys[i]])
            ? [...nested[keys[i]]]
            : { ...nested[keys[i]] };
          nested = nested[keys[i]];
        }

        const lastKey = keys[keys.length - 1];

        if (dataset && dataset.index !== undefined) {
          const idx = parseInt(dataset.index, 10);
          if (!Array.isArray(nested[lastKey])) {
            nested[lastKey] = [nested[lastKey]];
          }
          nested[lastKey][idx] = value;
        } else {
          nested[lastKey] = value;
        }

        return updated;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // const handleFileChange = ({ target: { name, files, dataset } }) => {
  //   const keyName = dataset.keyname;
  //   if (keyName) {
  //     setFiles((prev) => ({
  //       ...prev,
  //       otherKeys: {
  //         ...prev.otherKeys,
  //         [keyName]: files[0] || null,
  //       },
  //     }));
  //     setFileNames((prev) => ({
  //       ...prev,
  //       otherKeys: {
  //         ...prev.otherKeys,
  //         [keyName]: files[0]?.name || "",
  //       },
  //     }));
  //   } else {
  //     setFiles((prev) => ({
  //       ...prev,
  //       [name]: files[0],
  //     }));
  //     setFileNames((prev) => ({
  //       ...prev,
  //       [name]: files[0]?.name || "",
  //     }));
  //   }
  // };

  const handleFileChange = ({ target: { name, files, dataset } }) => {
    const file = files?.[0] || null;
    if (name.startsWith("otherKeys.")) {
      const [, keyName, field] = name.split(".");
      setFiles((prev) => ({
        ...prev,
        otherKeys: {
          ...prev.otherKeys,
          [keyName]: {
            ...(prev.otherKeys[keyName] || {}),
            [field]: file,
          },
        },
      }));
      setFileNames((prev) => ({
        ...prev,
        otherKeys: {
          ...prev.otherKeys,
          [keyName]: {
            ...(prev.otherKeys[keyName] || {}),
            [field]: file?.name || "",
          },
        },
      }));
      return;
    }
    setFiles((prev) => ({
      ...prev,
      [name]: file,
    }));
    setFileNames((prev) => ({
      ...prev,
      [name]: file?.name || "",
    }));
  };

  const nextStep = () => {
    const isValid = validateStep(activeStep, formData, files);
    if (isValid) {
      setStepValidated((prev) => ({ ...prev, [activeStep]: true }));
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      setValidate(false);
    } else {
      setStepValidated((prev) => ({ ...prev, [activeStep]: true }));
      setValidate(true);
    }
  };

  const prevStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const appendFormData = (formDataObj, keyPrefix, formdata) => {
    Object.entries(formDataObj).forEach(([key, value]) => {
      const fullKey = keyPrefix ? `${keyPrefix}[${key}]` : key;

      if (value === null || value === undefined) {
        formdata.append(fullKey, null);
        return;
      }

      if (value instanceof File) {
        formdata.append(fullKey, value);
        return;
      }

      if (Array.isArray(value)) {
        formdata.append(fullKey, JSON.stringify(value));
        return;
      }

      if (typeof value === "object") {
        appendFormData(value, fullKey, formdata);
        return;
      }

      formdata.append(fullKey, value);
    });

    return formdata;
  };

  const handleSubmission = async (e) => {
    e.preventDefault();

    const token = Cookies.get("jwt");
    const formdata = new FormData();
    setLoading(true);

    const mergedData = {
      ...formData,
      keyboard_full_image_watch_ad: files.keyboard_full_image_watch_ad,
      thumb_image: files.thumb_image,
      thumb_image_iphone: files.thumb_image_iphone,
      thumb_image_ipad: files.thumb_image_ipad,
      full_image_iphone: files.full_image_iphone,
      full_image_ipad: files.full_image_ipad,
      json_name: files.json_name,
      keyboard_bg_image: files.keyboard_bg_image,

      popup: {
        ...formData.popup,
        popupBgImage: files.popupBgImage,
        popupBgSideImage: files.popupBgSideImage,
      },
      keys: {
        ...formData.keys,
        bgImage: files.keysBgImage,
        keysIpadBgImage: files.keysIpadBgImage,
        keysBgImageLandscape: files.keysBgImageLandscape,
        keysIpadBgImageLandscape: files.keysIpadBgImageLandscape,
      },
        otherKeys: Object.keys(formData.otherKeys).reduce((acc, key) => {
        acc[key] = {
          ...formData.otherKeys[key],
          ...(files.otherKeys?.[key]?.bgImage
            ? { bgImage: files.otherKeys[key].bgImage }
            : {}),
          ...(files.otherKeys?.[key]?.ipadBgImage
            ? { ipadBgImage: files.otherKeys[key].ipadBgImage }
            : {}),
          ...(files.otherKeys?.[key]?.bgImageLandscape
            ? { bgImageLandscape: files.otherKeys[key].bgImageLandscape }
            : {}),
          ...(files.otherKeys?.[key]?.ipadBgImageLandscape
            ? { ipadBgImageLandscape: files.otherKeys[key].ipadBgImageLandscape }
            : {}),
        };
        return acc;
      }, {}),
      fontsPanel: {
        ...formData.fontsPanel,
        dropDownImage: files.dropDownImage,
      },
      fontsContent: {
        ...formData.fontsContent,
        fontsContentSelectionIconImage: files.fontsContentSelectionIconImage,
        gifBackImage: files.gifBackImage,
      },
    };

    const payload = appendFormData(mergedData, "", formdata);

    try {
      const res = await API.post("/keyboardThemes", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status === true) {
        toast.success("Data saved successfully!", {
          position: "bottom-right",
          autoClose: 500,
        });
        setLoading(false);
        navigate("/keyboard/theme");
      } else {
        toast.error(res.data.response_message || "Something went wrong!");
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ handleSubmission error:", error);
      setLoading(false);
      toast.error("Failed to save data!");
    }
  };

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Add Keyboard Theme</h3>
      </div>
      <div className="page-content">
        <Form noValidate validated={stepValidated[activeStep] || false}>
          <Row>
            <Col xs={12}>
              <Card className="mb-4">
                <Card.Header>
                  <Stepper
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    flag="add"
                  />
                </Card.Header>
                <Card.Body>
                  {React.createElement(stepComponents[activeStep], {
                    formData,
                    setFormData,
                    onInputChange,
                    handleFileChange,
                    fileNames,
                    files,
                    validate,
                  })}
                </Card.Body>
                <Card.Footer className="text-end">
                  <div className="d-flex justify-content-between">
                    <Button
                      variant="primary"
                      onClick={prevStep}
                      disabled={activeStep === 0}
                    >
                      Previous
                    </Button>
                    <div className="d-flex align-items-stretch">
                      {activeStep === steps.length - 1 ? (
                        <Button
                          variant="primary"
                          className="me-2 d-flex align-items-center gap-3"
                          onClick={handleSubmission}
                          disabled={loading}
                        >
                          {loading && (
                            <div
                              className="spinner-border text-light"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                          {loading ? "Saving..." : "Save Theme"}
                        </Button>
                      ) : (
                        <Button
                          className=""
                          variant="primary"
                          onClick={nextStep}
                        >
                          Next
                        </Button>
                      )}
                      <Link to="/keyboard/theme" className="ms-2 h-100 d-block">
                        <Button variant="outline-secondary h-100 d-block">
                          Cancel
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Layout>
  );
};

export default KeyboardThemeAdd;
